import React from "react";
import { useQuery } from "@apollo/client";
import { FrequentSearch } from "../component/FrequentSearch";
import { SEARCH_RENT_BUSINESS_FACETS_QUERY } from "../../../facets/queries";
import { cleanName } from "@coninsa-site/project/src/utils";
import { capitalize } from "@coninsa/utils";

type T_props = {
  title: string;
  propertyType?: string;
};

type T_facets = Array<{
  count: number;
  filter: string;
  type: "local" | "office";
}>;

export function BussinessFrequentSearch({ title }: T_props) {
  const { data, loading } = useQuery(
    SEARCH_RENT_BUSINESS_FACETS_QUERY,
    {
      variables: {
        and_conditions: [],
      },
    }
  );

  const { data: dataLocals, loading: loadingLocals } = useQuery(
    SEARCH_RENT_BUSINESS_FACETS_QUERY,
    {
      variables: {
        and_conditions: [{ name: "property_type", value: "Local" }],
      },
    }
  );

  const { data: dataOffices, loading: loadingOffices } = useQuery(
    SEARCH_RENT_BUSINESS_FACETS_QUERY,
    {
      variables: {
        and_conditions: [{ name: "property_type", value: "Oficina" }],
      },
    }
  );

  if (loading || loadingLocals || loadingOffices) {
    return null;
  }

  const cities = data?.search?.facets[0]?.values as T_facets;
  const locals = dataLocals?.search?.facets[0]?.values;
  const offices = dataOffices?.search?.facets[0]?.values;

  const consolidatedList = cities.map((item) => {
    const city = item.filter;
    const types = [];

    const hasLocals = locals.some((local) => local.filter === city);
    const hasOffices = offices.some((office) => office.filter === city);

    if (hasLocals) {
      types.push("local");
    }

    if (hasOffices) {
      types.push("office");
    }

    return { ...item, types };
  }) as T_facets;

  const list = consolidatedList.reduce((acc, item) => {
    const cityPath = `/arrendamientos/comercio/ciudad/${cleanName(item.filter)}`;

    if (item.types.length === 0) {
      acc.push({
        id: item.filter,
        label: `En ${capitalize(item.filter)}`,
        path: cityPath,
        title: `Inmuebles de comercio en arriendo en ${capitalize(item.filter)}`,
      });
    }

    if (item.types.includes("local")) {
      acc.push({
        id: item.filter,
        label: `Local en ${capitalize(item.filter)}`,
        path: `${cityPath}/tipo-de-inmueble/local`,
        title: `Inmuebles de comercio en arriendo en ${capitalize(item.filter)}`,
      });
    }

    if (item.types.includes("office")) {
      acc.push({
        id: item.filter,
        label: `Oficina en ${capitalize(item.filter)}`,
        path: `${cityPath}/tipo-de-inmueble/oficina`,
        title: `Inmuebles de comercio en arriendo en ${capitalize(item.filter)}`,
      });
    }
    return acc;
  }, [])

  return <FrequentSearch list={list} subTitle={title} />;
}
